/**
 * Keyboard escape hatch past the navigation.
 *
 * Visually hidden until focused, then pinned to the top-left. This is the
 * first focusable element in the document, which is what lets a keyboard or
 * screen-reader user reach the content without tabbing through the header on
 * every page.
 */
const SkipLink = ({ targetId = 'main-content' }) => (
  <a className="skip-link" href={`#${targetId}`}>
    Skip to main content
  </a>
);

export default SkipLink;
